import { Component, forwardRef, Input, OnDestroy, ViewChild } from '@angular/core';
import { ControlContainer, ControlValueAccessor, FormsModule, NG_VALUE_ACCESSOR, NgForm } from '@angular/forms';
import { Subscription } from 'rxjs';
import { BelegSearchRequestMeta } from '../../../core/gb-api';
import { GbAmtSearchMode } from '../gb-amt/gbAmtSearchMode';
import { GbAmtComponent } from '../gb-amt/gb-amt.component';
import { CapFormRowDirective } from '../../form-control/cap-form-row.directive';
import { CapFormControlComponent } from '../../form-control/form-control.component';
import { MetaDisablerDirective } from '../../directives/meta-disabler.directive';
import { MetaValidatorDirective } from '../../directives/meta-validator.directive';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'cap-widg-beleg',
  templateUrl: './beleg.component.html',
  styleUrls: ['./beleg.component.scss'],
  providers: [{ provide: NG_VALUE_ACCESSOR, useExisting: forwardRef(() => BelegComponent), multi: true }],
  viewProviders: [{ provide: ControlContainer, useExisting: NgForm }],
  imports: [
    CapFormRowDirective,
    CapFormControlComponent,
    GbAmtComponent,
    FormsModule,
    MetaDisablerDirective,
    MetaValidatorDirective,
    TranslatePipe
  ]
})
export class BelegComponent implements OnDestroy, ControlValueAccessor {
  @ViewChild(GbAmtComponent, { static: false })
  private gbAmt: GbAmtComponent;

  @Input()
  name: string;

  @Input()
  heading: string;

  @Input()
  searchMode: GbAmtSearchMode;

  model: BelegSearchRequestMeta = {};

  private _subscription: Subscription;

  onTouched: () => void = () => {};
  onChanged: () => void = () => {};

  writeValue(obj: any): void {
    this.model = obj;
  }

  registerOnChange(fn: any): void {
    this.onChanged = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  ngOnDestroy(): void {
    this._subscription?.unsubscribe();
  }

  emptyBelegSearch() {
    this.gbAmt.onClear();
  }

  onReset() {}
}
